module.exports = __webpack_public_path__ + "img/crm_case11.7d96eb65.png";